function TopHead() {
  return (
    <>
      <>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap"
          rel="stylesheet"
        />
      </>
      <div className="whole">
        <div className="row">
          <div className="first_four_images col-3 d-flex justify-content-evenly mt-1">
            <a href="">
              <img
                id="LFE"
                src="images\04-Life final logo.png"
                alt="LFE"
                width="105"
                height="55"
                style={{ marginTop: "10px", marginLeft: "4px" }}
              />
            </a>
            <a href="">
              <img
                id="G20"
                src="images\G20_India_2023_logo.png"
                alt="G20"
                width="95"
                height="65"
                style={{ marginTop: "5px", marginLeft: "8px" }}
              />
            </a>
            <a href="">
              <img
                id="EIACP"
                src="images\EIACP_Logo.png"
                alt="EIACP"
                width="63"
                style={{ marginTop: "5px", marginLeft: "8px" }}
              />
            </a>
            <a href="">
              <img
                id="ENVIS"
                src="images\ENVIS Logo_FINAL.png"
                alt="ENVIS"
                width="63"
                style={{ marginTop: "1px", marginLeft: "8px" }}
              />
            </a>
          </div>
          <div className="heading col-6" style={{ marginLeft: "0px" }}>
            <h7
              style={{
                textAlign: "center",
                fontFamily: "'Nunito'",
                color: "black",
                marginLeft: "50px",
                marginTop: "7px",

                fontSize: "0.93em",
              }}
            >
              <b>
                EMERGING ROLE OF GEOGRAPHICAL INFORMATION SYSTEM (GIS), LIFE
                CYCLE{" "}
                <span style={{ marginLeft: "14px" }}>
                  ASSESSMENT (LCA) AND SPATIAL LCA (GIS-LCA) IN SUSTAINABLE
                  BIOENERGY PLANNING
                </span>
              </b>
              <br />

              <div style={{ fontSize: "0.9em" }}>
                <strong>
                  <a id="searchlink2" href="#" rel="subcontent2">
                    Moonmoon Hiloidhari<sup>a</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink4" href="#" rel="subcontent4">
                    D.C. Baruah<sup>bb</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    Anoop Singh<sup>c</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    Sampriti Kataki<sup>b</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    Kristina Medhi<sup>a</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    Shilpi Kumari<sup>d</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    T.V Ramachandra<sup>e</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    B.M Jenkins<sup>f</sup>
                  </a>
                  &nbsp;
                  <a id="searchlink1" href="#" rel="subcontent1">
                    Indu Shekhar Thakur<sup>a</sup>
                  </a>
                </strong>
              </div>
              <div style={{ fontSize: "0.8em" }} className="style33">
                <span className="style16">
                  <sup>a</sup>School of Environmental Sciences, Jawaharlal Nehru
                  University, New Delhi 110067, India,
                  <br />
                  <sup>b</sup>Department of Energy, Tezpur University, Tezpur
                  784028, Assam, India&nbsp;
                  <sup>c</sup>Department of Scientiﬁc and Industrial Research,
                  Ministry of Science and Technology, Government of India, New
                  Delhi 110016, India
                  <br />
                  <sup>d</sup>
                  Centre for Energy Studies, Indian Institute of Technology
                  Delhi, New Delhi 110016, India
                  <br />
                  <sup>e</sup>
                  eEnergy and Wetland Research Group, Centre for Ecological
                  Sciences, Indian Institute of Science, Bangalore 560012, India
                  <br /> <sup>f</sup>
                  Department of Biological and Agricultural Engineering,
                  University of California Davis, California 95616, USA
                  <br />
                  *Corresponding author:
                </span>
                <span className="style16">
                  &nbsp;
                  <a
                    title="mailto:cestvr@ces.iisc.ac.in"
                    href="mailto:cestvr@ces.iisc.ac.in"
                  >
                    cestvr@ces.iisc.ac.in
                  </a>
                </span>
              </div>
            </h7>
          </div>

          <div
            style={{
              filter: "brightness(100%)",
              mixBlendMode: "multiply",
              marginTop: "7px",
              marginRight: "0px",
            }}
            className="col-3 second_four_images  d-flex justify-content-evenly mt-1"
          >
            <a href="">
              <img
                id="IISc"
                src="images\IISc_Master_Seal.jpg"
                alt="IISc"
                width="78"
              />
            </a>
            <a href="">
              <img src="images\EWRG_logo.jpeg" alt="EWRG" width="70" />
            </a>
            <a href="">
              <img
                id="NE"
                src="images\National Emblem (1).png"
                alt=""
                width="60"
                style={{ marginTop: "3px" }}
              />
            </a>
            <a href="">
              <img
                src="images/Aazadi_ka_amrit_mahotsav_logo.png"
                alt="AKAM"
                width="100"
                height="65"
                style={{ marginTop: "5px" }}
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default TopHead;
